const PATH = 'fe.pages.calibrations.score_report';

const messages = {
  pageTitle: {
    key: `${PATH}.page_title`,
    defaultValue: 'CLASS Calibration Score Report'
  },
  title: {
    key: `${PATH}.title`,
    defaultValue: 'Calibration Report'
  },
  subtitle: {
    key: `${PATH}.subtitle`,
    defaultValue: 'Review your performance on your most recent attempt.'
  },
  logoDescription: {
    key: `${PATH}.logo_description`,
    defaultValue: 'CLASS Calibration Logo'
  },
  calibration: {
    key: `${PATH}.calibration`,
    defaultValue: 'the CLASS Calibration'
  },
  columnTitle: {
    key: `${PATH}.column_title`,
    defaultValue: 'Domain/Dimension'
  },
  userScore: {
    key: `${PATH}.user_score`,
    defaultValue: 'Your Score'
  },
  expertCode: {
    key: `${PATH}.expert_code`,
    defaultValue: 'Expert Code'
  },
  reliable: {
    key: `${PATH}.reliable`,
    defaultValue: 'Reliable?'
  },
  reliableDescription: {
    key: `${PATH}.reliable_description`,
    defaultValue:
      'The CLASS is a complex measurement tool. Calibration can help you hone your skills in CLASS coding. Below you will find details of your performance at the dimension level to assist you in identifying areas for improvement.'
  },
  tableTitle: {
    key: `${PATH}.table_title`,
    defaultValue: 'Test Results by Dimension'
  },
  classSecondEdition: {
    key: `${PATH}.class_second_edition`,
    defaultValue: '2ND EDITION'
  },
  unavailableTitle: {
    key: `${PATH}.unavailable_title`,
    defaultValue: 'Score report no longer available'
  },
  unavailableDescription: {
    key: `${PATH}.unavailable_description`,
    defaultValue:
      'Score reports are available for one year after you complete a calibration.'
  },
  backToHistory: {
    key: `${PATH}.back_to_history`,
    defaultValue: 'Back to Calibration History'
  }
};

export default messages;
